import React, { useEffect, useState } from 'react'
import Header from "../template/Header";
import Menu from "../template/Menu";
import Footer from "../template/Footer";
import Loading from "../components/loading/Loading";
import { Button, Col, Row } from "react-bootstrap";
import TableData from "../components/table/TableData"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight,faMagnifyingGlass,faPlus } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';
import { alertMinus } from "../components/alertValid/AlertValid.js"
import {
    textSearchBtn,
    textResetBtn,
    textCreateBtn,
    colorSearchBtn,
    colorResetBtn,
    colorCreateBtn,
    iconSearchBtn,
    iconResetBtn,
    iconCreateBtn,
    hoverSearchBtn,
    hoverResetBtn,
    hoverCreateBtn,
    textSaveBtn,
    textCancleBtn,
    colorSaveBtn,
    colorCancleBtn,
    hoverSaveBtn,
    hoverCancleBtn,
    colorEditBtns,
    hoverEditBtns
} from "../components/ThemeConfig/btnConfig";
import { useButtonDynamicStyles } from "../components/useDynamic/Button_DynamicStyle";
import formatDatetime from "../utils/formatDateTime.js";
import { getPromotion, deletePromotion } from "../api/promotion_api.js"
import Modal from 'react-bootstrap/Modal';
import Pinned from './modal/Pinned.js';

function Privilege() {
    useButtonDynamicStyles(
        textSearchBtn,
        textResetBtn,
        textCreateBtn,
        colorSearchBtn,
        colorResetBtn,
        colorCreateBtn,
        iconSearchBtn,
        iconResetBtn,
        iconCreateBtn,
        hoverSearchBtn,
        hoverResetBtn,
        hoverCreateBtn,
        textSaveBtn,
        textCancleBtn,
        colorSaveBtn,
        colorCancleBtn,
        hoverSaveBtn,
        hoverCancleBtn,
        colorEditBtns,
        hoverEditBtns
    );
    
    const [isLoading, setLoading] = useState(false);

    const [dataSearch, setDataSearch] = useState({
        search: "",
    });

    const navigate = useNavigate();
    const navigateToAddPage = () => {
        navigate("/a&eInfoPrivilege");
    };

    const [dataTable, setDatatable] = useState([]);

    const dataHeader = [
        { label: "No",column:'no' , style: { width: "10%", borderLeft: "1px solid #000",borderTopLeftRadius: "10px",borderTopRightRadius: "0px",borderBottomLeftRadius: "10px"
        ,borderBottomRightRadius: "0px",position:'relative' },status: true
        },
        { label: "Title",column:'title_en' , style: { width: "25%",borderRadius: "0px",position:'relative' }, status: true },
        { label: "Update",column:'updated_at', style: { width: "20%",borderRadius: "0px",position:'relative' }, status: true },
        { label: "Status",column:'active' , style: { width: "20%",borderRadius: "0px",position:'relative' }, status: true },
        { label: "Action",column:'action', style: { width: "15%",borderRight: "1px solid #000",borderTopRightRadius: "10px",borderTopLeftRadius: "0px",borderBottomRightRadius: "10px",borderBottomLeftRadius: "0px"
        ,position:'relative' } }
    ];
    const [tableParam, setTableParam] = useState({
        sorting:{ column: "", order: "" },
        pageNumber:1,
        dataPerPage:10,
    }); //กำหนด column เริ่มต้นในการ sort
    const [totalNumber, setTotalNumber] = useState(0)
    useEffect(()=>{
        getTableData()
    },[tableParam])
    // const seachTable = (column,value) => {
    //     setTableParam((prevTableParam) => ({
    //         ...prevTableParam,
    //         searching: {...prevTableParam.searching,[column]:value},
    //       }));
    //   //newSorting example 
    // };
    const sortTable = (newSorting) => {
        setTableParam((prevTableParam) => ({
            ...prevTableParam,
            sorting: newSorting,
        }));   
    };    
    const changePage = (pageNumber) => {
        setTableParam((prevTableParam) => ({
            ...prevTableParam,
            pageNumber: pageNumber,
        }));   
      //newSorting example 1
    };
    const changeDataPerPage = (dataPerPage) => {
        setTableParam((prevTableParam) => ({
            ...prevTableParam,
            dataPerPage: dataPerPage,
        }));   
      //newSorting example 10
    };

    async function getTableData() {
        try {
            await setLoading(true);
            const param = {
                type: 'priv',
                search: dataSearch.search,
                sort_by:tableParam.sorting.column=='no'?'_id':tableParam.sorting.column,
                order_by:tableParam.sorting.order,
                page_number:tableParam.pageNumber,
                data_per_page:tableParam.dataPerPage,
            }
            let response = await getPromotion(param);

            let tmpDataTable = [];
            setTotalNumber(response.data.meta.total)
            for (let i = 0; i < response.data.data.length; i++) {
                const ascendingNo = { data: (i + 1)+((tableParam.pageNumber-1)*tableParam.dataPerPage) };
                const descendingNo = { data: response.data.meta.total - ((tableParam.pageNumber - 1) * tableParam.dataPerPage) - i };
                let model = {
                    no: tableParam.sorting.order == 'desc'&& tableParam.sorting.column=='no' ?
                            descendingNo:ascendingNo,
                    user_id: { data: response.data.data[i]._id
                        ,isHide: true,},
                    name: { data: response.data.data[i].title_en },
                    updated_at: {
                        data: response.data.data[i].update_by+ ' | ' + formatDatetime(response.data.data[i].updated_at),
                    },
                    active: {
                        data: response.data.data[i].active == 1 ? "Active" : "Inactive",
                        style: {
                            color: response.data.data[i].active == 1 ? "#87BD66" : "#D95350",
                        },
                    },
                    action: {
                        view: false,
                        create: false,
                        delete: true,
                        update: false,
                        edit: true,
                    },
                };
                tmpDataTable.push(model);
            }
            setDatatable(tmpDataTable)
        } catch (error) {
            console.log('err getTableData',error)
        }
        await setLoading(false);
    }

    const handleSearchBtn = async () => {
        getTableData();
    };

    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

  return (
    <>
        {isLoading ? <Loading /> : ""}
        <Header parentmenu={"PROMOTION & PRIVILEGE"} />
        <Menu
            parentmenu={"infoPromotionPrivilege"}
            activemenu={"infoPrivilege"}
        />
        <div className="content-wrapper">
            <div className="container-fluid pdb-page">
                <div className="box-white">
                    <Row>
                        <Col xs={12}>
                            <font className="font-size07 colorBlack01 fontBold d-flex align-items-center">
                                <img src="assets/icons/ic-promotion.png" className="ic-user01 me-2" alt="" />
                                PROMOTION & PRIVILEGE<FontAwesomeIcon icon={faChevronRight} className="h-8 p-2" /> PRIVILEGE
                            </font>
                        </Col>
                    </Row>
                    <div className='mx-5'>
                        <Row className='mt-3 d-flex justify-content-end'>
                            <Col xl={12} xxl={10}>
                                <Row>
                                    <Col xs={10} className="d-flex justify-content-end align-items-center">
                                        <label className="fontLight font-size01 colorBlack01 mb-0 me-2">
                                            Search:
                                        </label>
                                        <input
                                                type="text"
                                                className="inp02 fontLight font-size03"
                                                id="inp_search"
                                                placeholder="Search by Title"
                                                value={dataSearch.search}
                                                onChange={(event) => setDataSearch({ ...dataSearch, search: event.target.value })}
                                        />
                                    </Col>
                                    <Col xs={2} className="d-flex justify-content-end">
                                        <Button className="btn-search"
                                            onClick={(e) => {
                                                handleSearchBtn(dataSearch);
                                            }}
                                        >
                                            
                                            <FontAwesomeIcon icon={faMagnifyingGlass} className="colorBlack01 me-2"/>
                                            Search
                                        </Button>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                        <Row className="mt-4">
                            <Col xs={6} xl={5} xxl={4}>
                                <Button className="btn-create" onClick={() => navigateToAddPage()}>
                                    <FontAwesomeIcon icon={faPlus} className="colorWhite me-2"/>
                                    Add
                                </Button>

                                <Button className="btn-create ms-3" onClick={handleShow}>
                                    <FontAwesomeIcon icon={faPlus} className="colorWhite me-2"/>
                                    pinned top 5
                                </Button>
                            </Col>
                        </Row>
                        <Row>
                            <TableData
                                dataHeader={dataHeader}
                                editUrl={"/a&eInfoPrivilege?id="}
                                dataTable={dataTable}
                                idName={"user_id"}
                                removeData={(id) => alertMinus(id, deletePromotion)}
                                tableParam={tableParam}
                                sortTable={sortTable}
                                changePage={changePage}
                                changeDataPerPage={changeDataPerPage}
                                totalNumber={totalNumber}
                                tablePermission={{
                                    view: false,
                                    create: false,
                                    delete: true,
                                    update: false,
                                    edit: true,
                                }}
                            />
                        </Row>
                        <Modal show={show} onHide={handleClose}>
                            <Modal.Body className="p-4"><Pinned type="priv" /></Modal.Body>
                        </Modal>
                    </div>
                </div>
            </div>
        </div>
        <Footer/>
    </>
  )
}

export default Privilege;